import React from 'react';

/**
 * Solid “message with captions” affordance (Font Awesome semantic: fa-message-captions).
 * The free npm kit does not export that icon name; the bubble path matches Font Awesome Free
 * 6.7.2 message.svg; caption bars are added for the subtitles/captions cue.
 */
export const MessageCaptionsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 512 512"
    aria-hidden
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l96 0 0 80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0z"
    />
    <g fill="currentColor" opacity={0.42}>
      <rect x="112" y="168" width="288" height="36" rx="10" />
      <rect x="112" y="232" width="248" height="36" rx="10" />
      <rect x="112" y="296" width="208" height="36" rx="10" />
    </g>
  </svg>
);
